<template>
  <nav v-style="{ bg: backgroundColor, c: titleColor }" :aria-label="title">
    <div class="flex gap-8 py-3 container <lg:hidden" :class="{ between: alignment === 'right' }">
      <h2 class="title-3">
        <cms-plain-text :content field-name="title" />
      </h2>
      <ul class="flex" :class="divider ? 'gap-4' : 'gap-8'">
        <li v-for="({ text, url, targetAttribute }, key) in targets" :key>
          <vf-link :target="targetAttribute" :to="url" variant="quiet">
            {{ text }}
          </vf-link>
          <span v-if="divider && key !== targets.length - 1" class="ml-4">{{ divider }}</span>
        </li>
      </ul>
    </div>
    <vf-accordion ref="accordionRef" v-model:open="opened" class="b-0 lg:hidden">
      <template #title>
        <cms-plain-text :content field-name="title" />
      </template>
      <ul :aria-hidden="!opened" :hidden="!opened" :inert="!opened">
        <li v-for="({ text, url, targetAttribute }, key) in targets" :key class="b-t b-grey-70 py-2">
          <vf-link class="block" :target="targetAttribute" :to="url" variant="quiet" @click="opened = false">
            {{ text }}
          </vf-link>
        </li>
      </ul>
    </vf-accordion>
  </nav>
</template>

<script lang="ts" setup>
import type { SecondaryNavContent } from '#types/components/cms/secondary-nav'
import { DynamicFieldsKey } from '#content/contexts/dynamic-fields'
import { useFocusTrap } from '@vueuse/integrations/useFocusTrap'

const { content } = defineProps<{
  content: SecondaryNavContent
}>()

const { alignment, backgroundColor, countdown, targets, title, titleColor } = content
const { divider } = useAppConfig().components.cms.secondaryNav

const opened = ref(false)
const accordionRef = ref<HTMLElement | null>(null)
const { activate, deactivate } = useFocusTrap(accordionRef)

watch(opened, (isOpen) => {
  if (isOpen) nextTick(() => activate())
  else deactivate()
})

onUnmounted(() => deactivate())

countdown && provide(DynamicFieldsKey, { countdown })
</script>
